import React from "react";
import CompactSelect from "./CompactSelect";

/**
 * Unified listing filters: dates, status, user, actions, search, clear.
 */
const ListingFilters = ({
  startDate,
  endDate,
  onStartDate,
  onEndDate,
  showDates = true,
  search,
  onSearch,
  searchPlaceholder = "Search",
  showSearch = true,
  status,
  onStatus,
  statusOptions,
  statusLabel = "Status",
  userId,
  onUserId,
  userOptions,
  userLabel = "User",
  actions,
  onApply,
  applyLabel = "Load Records",
  showApply = false,
  onClear,
  showClear = true,
  clearLabel = "Clear",
  className = "",
}) => {
  const canClear = showClear && typeof onClear === "function";

  return (
    <div className={`ds-listing-filters ${className}`.trim()}>
      <div className="ds-listing-filters__left">
        {showDates && (
          <div className="ds-listing-dates">
            <label className="ds-listing-field">
              <span className="ds-listing-field__label">From</span>
              <input
                type="date"
                value={startDate || ""}
                onChange={(e) => onStartDate?.(e.target.value)}
                className="ds-input ds-filter-date"
              />
            </label>
            <label className="ds-listing-field">
              <span className="ds-listing-field__label">To</span>
              <input
                type="date"
                value={endDate || ""}
                onChange={(e) => onEndDate?.(e.target.value)}
                className="ds-input ds-filter-date"
              />
            </label>
          </div>
        )}

        {Array.isArray(statusOptions) && statusOptions.length > 0 && (
          <label className="ds-listing-field">
            <span className="ds-listing-field__label">{statusLabel}</span>
            <CompactSelect
              className="ds-filter-status-select"
              value={status || ""}
              onChange={(v) => onStatus?.(v)}
              options={statusOptions}
              placeholder="All"
              ariaLabel="Status"
            />
          </label>
        )}

        {Array.isArray(userOptions) && userOptions.length > 0 && (
          <label className="ds-listing-field">
            <span className="ds-listing-field__label">{userLabel}</span>
            <CompactSelect
              className="ds-filter-user-select"
              value={userId || ""}
              onChange={(v) => onUserId?.(v)}
              options={userOptions}
              placeholder="All Users"
              ariaLabel="User"
            />
          </label>
        )}

        {actions ? <div className="ds-listing-actions">{actions}</div> : null}

        {showApply && onApply ? (
          <button
            type="button"
            className="ds-btn ds-btn-primary ds-filter-apply"
            onClick={onApply}
          >
            {applyLabel}
          </button>
        ) : null}

        {canClear ? (
          <button
            type="button"
            className="ds-btn ds-btn-secondary ds-btn-sm ds-filter-clear"
            onClick={onClear}
          >
            {clearLabel}
          </button>
        ) : null}
      </div>

      <div className="ds-listing-filters__right">
        {showSearch && (
          <input
            type="search"
            value={search || ""}
            onChange={(e) => onSearch?.(e.target.value)}
            placeholder={searchPlaceholder}
            className="ds-input ds-filter-search"
          />
        )}
      </div>
    </div>
  );
};

export default ListingFilters;
